export default "__VITE_ASSET__ug7Ej_BH__"